// src/components/card/feature-card.tsx
import * as React from 'react';
import { Card, CardContent } from '@/components/ui/card';
const planStyles = {
    free: 'bg-gray-100 text-gray-700 border border-gray-300 dark:bg-gray-900/40 dark:text-gray-200 dark:border-gray-700',
    solo: 'bg-primary/10 text-primary border border-primary/25',
    team: 'bg-violet-500/10 text-violet-500 border border-violet-500/30',
};
const planLabels = {
    free: 'Free',
    solo: 'Solo',
    team: 'Team',
};
export const FeatureCard = ({ title, body, plans }) => {
    return (<Card className="h-full">
            <CardContent className="p-4 space-y-3">
                {plans?.length && (<div className="flex flex-wrap items-center gap-1.5">
                        {plans?.map((plan) => (<span key={plan} className={`inline-flex items-center rounded-full px-2 py-0.5 text-[10px] font-medium uppercase tracking-wide ${planStyles[plan]}`}>
                                {planLabels[plan]}
                            </span>))}
                    </div>)}

                <h3 className="text-sm font-semibold">{title}</h3>
                <p className="text-xs text-muted-foreground">{body}</p>
            </CardContent>
        </Card>);
};
